module.exports = __webpack_public_path__ + "img/foto24.7a66b9bf.jpg";